import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import { OtherOptions } from 'Views/Authentication/Components/OtherOptions';
import fr from 'facet-rest';
import {
  AuthenticationLayout,
  AuthenticationLayoutForm,
  AuthenticationSubmitButton,
  LoginWithPasskeyButton,
  OtherMFAButton,
  ResendVerificationCodeButton,
  MFAResetButton,
  BackToEmailStepButton,
} from '../../Components';

export const AuthMultiFactorSMSLayout = ({ setAuthCollection }) => {
  const { resource, onSubmit, unsourcedErrors } = useMetaLayoutContext();

  return (
    <AuthenticationLayout>
      <AuthenticationLayoutForm
        id={'mfa-sms-form'}
        onSubmit={onSubmit}
        errors={unsourcedErrors}
      >
        <FDStack direction={'column'} spacing={2}>
          <BackToEmailStepButton resource={resource} setAuthCollection={setAuthCollection} />
          <MetaControlField attr={'code'} {...dataAttrs('input-mfa-code')} />
          <MetaControlField attr={'rememberDevice'} {...dataAttrs('input-mfa-remember-device')} />
          <AuthenticationSubmitButton />
          <ResendVerificationCodeButton setAuthCollection={setAuthCollection} />
          <OtherOptions
            resource={resource}
            relationships={[
              fr.relationships.mfaPreferenceTotp.name,
              fr.relationships.passkeyLoginChallenge.name,
            ]}
          />
          <OtherMFAButton mfaType={'totp'} setAuthCollection={setAuthCollection} />
          <LoginWithPasskeyButton setAuthCollection={setAuthCollection} />
          <MFAResetButton />
        </FDStack>
      </AuthenticationLayoutForm>
    </AuthenticationLayout>
  );
};

AuthMultiFactorSMSLayout.propTypes = {
  setAuthCollection: PropTypes.func.isRequired,
};
